import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Pré-requisito do Configuration Server: sem scope items aprovados no
 * Fit-to-Standard, não há o que extrair. A mensagem diz o que fazer, e o
 * link leva ao lugar onde se faz.
 */
export function ScopePrerequisiteBanner({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      className="flex items-start gap-2.5 rounded-md border border-amber-200 bg-amber-50 px-3.5 py-3"
    >
      <Lock className="mt-0.5 h-4 w-4 shrink-0 text-[#b45309]" />
      <div className="space-y-1">
        <p className="m-0 text-sm font-medium text-[#8a5200]">
          {t("Select and approve the scope items to start the configuration.")}
        </p>
        <Link
          to={`/projects/${projectId}/agents/functional`}
          className="text-[12px] font-semibold text-[#8a5200] underline underline-offset-2"
        >
          {t("Go to Fit-to-Standard")}
        </Link>
      </div>
    </div>
  );
}
